import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { OverlayComponent } from '../components/overlay/overlay.component';


// providedIn was commented out.  uncommented to make error handler service work.
@Injectable({
  providedIn: 'root'
})
//@Injectable()
export class OverlayService {
  private overlayRef: OverlayRef = null;

  constructor(private overlay: Overlay) { }

  public show() {
    setTimeout(() => {
      this.showSpinner();
    }, 1);
  }

  private showSpinner() {
    // Returns an OverlayRef (which is a PortalHost)
    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create();
    }

    // Create ComponentPortal that can be attached to a PortalHost
    if (!this.overlayRef.hasAttached()) {
      const overlayPortal = new ComponentPortal(OverlayComponent);
      const component = this.overlayRef.attach(overlayPortal); // Attach ComponentPortal to PortalHost
    }
  }

  public hide() {
    if (!!this.overlayRef) {
      this.overlayRef.detach();
    }
  }
}
